export function getFullName(user) {
    if (!user) {
        return '-';
    }
    return "".concat(user.first_name, " ").concat(user.last_name);
}
